import { HooksContainer as Hooks } from './HooksContainer'

// eslint-disable-next-line import/no-default-export
export default Hooks
